export const TERM_LIFE_OPTIONS = [
  { year: '1', productCode: 'term-life' },
  { year: '5', productCode: 'term-level-life-5' },
  { year: '10', productCode: 'term-level-life-10' },
  { year: '20', productCode: 'term-level-life-20' },
] as const;

export type TermLifeYear = (typeof TERM_LIFE_OPTIONS)[number]['year'];

export const TERM_LIFE_YEAR_TO_PRODUCT_CODE: Record<TermLifeYear, string> =
  TERM_LIFE_OPTIONS.reduce(
    (acc, { year, productCode }) => ({ ...acc, [year]: productCode }),
    {} as Record<TermLifeYear, string>,
  );

const VALID_TERM_LIFE_YEARS = new Set<string>(
  TERM_LIFE_OPTIONS.map(o => o.year),
);

export const toSafeTermLifeYear = (year: string | undefined): TermLifeYear =>
  VALID_TERM_LIFE_YEARS.has(year as string) ? (year as TermLifeYear) : '1';
